import React from 'react';
import { LdgGraphExplorer } from '../content/ldgGraph';
export function LdgGraphPage() {
  return <div className="h-full flex flex-col bg-white" data-id="element-6133">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex-shrink-0" data-id="element-6134">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-6135">
          Leerpad Graaf (LDG)
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-6136">
          Interactieve visualisatie van alle vraagfamilies en hun onderlinge
          afhankelijkheden.
        </p>
      </div>

      {/* Graph Explorer - takes full remaining height */}
      <div className="flex-1 relative overflow-hidden" data-id="element-6137">
        <LdgGraphExplorer data-id="element-6138" />
      </div>
    </div>;
}